import React from 'react'
import ClassNames from 'classnames'
import { InputSearchStyle } from './styled'
import { Image, Button } from '../../components'
import { ICONS } from '../../themes'

/**
 * Input description
 * - ...
 */

export class InputSearch extends React.PureComponent {
  render() {
    const {
      className,
      label,
      type,
      id,
      name,
      placeholder,
      isHorizontal,
      isIconClickable,
      onKeyDown,
      onClickSearchIcon,
      onClickSearchClear,
      onChange,
      value,
      clear,
    } = this.props
    return (
      <InputSearchStyle
        className={ClassNames(
          'input-search-control',
          { 'is-horizontal': isHorizontal },
          className
        )}
      >
        {label && (
          <label className="label" htmlFor={id}>
            {label}
          </label>
        )}

        <div className="input-wrapper">
          {isIconClickable && onClickSearchIcon ? (
            <Button className="link" onClick={onClickSearchIcon}>
              <Image
                src={ICONS['icon-search.svg']}
                className="search-input-icon"
              />
            </Button>
          ) : (
            <Image
              src={ICONS['icon-search.svg']}
              className="search-input-icon"
            />
          )}

          <input
            className="input"
            type={type}
            id={id}
            name={name}
            placeholder={placeholder}
            onKeyDown={onKeyDown}
            onChange={onChange}
            value={value}
            clear={clear}
          />

          {clear && value !== '' && value !== undefined && (
            <Button className="link" onClick={onClickSearchClear}>
              <img
                src={ICONS['icon-delete-circle-red.svg']}
                alt="Image"
                className="search-input-icon pointer"
                style={{ marginRight: '10px' }}
              />
            </Button>
          )}
        </div>
      </InputSearchStyle>
    )
  }
}

InputSearch.defaultProps = {
  isIconClickable: true,
  onClickSearchIcon: () => {},
  onClickSearchClear: () => {},
}
